import { ItemInventory } from 'apis/inventory-management-service/types';
import { Item, Option } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { Offer } from 'modules/shared-menu/pages/SharedMenuEditorPage/types';

import { validateItemPurchasability } from '../../../utils';
import { ItemQuantity } from '../../types';

export const getPurchasabilityValidationErrors = (options: Option[], item: Item) =>
  validateItemPurchasability(options, item).map(validationError => {
    const optionBinding = item.option_bindings.find(ob => ob.id === validationError.optionBindingId);
    if (!optionBinding) {
      throw new Error(`No option binding found with id ${validationError.optionBindingId}`);
    }
    const option = options.find(o => o.id === optionBinding.option_id);
    if (!option) {
      throw new Error(`No option found with id ${optionBinding.option_id}`);
    }
    return {
      optionName: option.name,
      error: validationError.error,
    };
  });

export const transformItemInventoryToQuantity = (itemInventory: ItemInventory): ItemQuantity => {
  const balance = itemInventory.balance || 0;
  const reserved = itemInventory.reservations.reduce((acc, value) => acc + value.reservedCount, 0) || 0;
  return {
    balance,
    reserved,
    available: (itemInventory.balance || 0) - reserved,
  };
};

export const getUniqueImageUrls = (item: Item | Offer) => [
  ...new Set([
    ...(item.image ? [item.image] : []),
    ...(item.images ?? [])
      .filter(img => {
        const hasBlurhashToCompare = img.blurhash && item.image_blurhash;
        if (!hasBlurhashToCompare) {
          return img;
        }
        return img.blurhash !== item.image_blurhash;
      })
      .map(img => img.url),
  ]),
];
